
import {InfoSec, InfoRow, InfoColumn, TextWrapper, TopLine, Heading, Subtitle, ImgWrapper, Img} from './InfoSection.elements'
import { Container } from '../../globalStyles'
import { Carousel,  } from 'antd';
import '../css/VideoBlackHole.css';

   


export const homeObjOne = {

    topLine: 'Consultoría',
    headline: ' Mejore la eficiencia de sus operaciones mediante el diseño e Implementación de Sistemas de Gestión ISO',
    description:
      'ISO/IEC 27001, ISO 9001, ISO 14001, ISO 45001',
    imgStart: '',
    //img: require('../../images/svg-3.svg'),
    img:require('../../images/profile.jpg'),
    alt: 'Consultoría', 
    start: ''
  };
  
  export const homeObjTwo = {

    topLine: 'Capacitación y Certificación',
    headline: 'Desarrolle el Capital Humano que Liderará el Futuro de su Organización en Materia de Ciberseguridad y Protección de Datos Personales',
    description:
      "Todo lo que necesitas para gestionar la protección de datos personales y la seguridad digital de tu empresa",
    imgStart: 'start',
    img: 'https://as2.ftcdn.net/v2/jpg/17/18/60/77/1000_F_1718607774_hPGZrJqVyAJCt3zpFATorkBSl4e42cI9.jpg',
    alt: 'Capacitación y Certificación',
    start: ''
  };
  
  export const homeObjThree = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Seguridad Digital',
    headline:
      'Mantén tu empresa confiable, íntegra y disponible.  Ante ataques de ransomware, filtraciones de datos, fraudes financieros y extorsiones cibernéticas.',
    description:
      "Permita el buen funcionamiento de la empresa mediante software y hardware que funcione de manera óptima.",
    imgStart: 'start',
     img: require('../../images/svg-3.svg'),
    alt: 'Vault',
    start: 'true'
  };

  const lightBg = false;
  const imgStart = false;
 //primary: false,
   const lightTopLine = true;
   const lightText = true;
   const lightTextDesc = true;



 const InfoSection = () => {
    return (
        <>
        <div    className="video-container">
                                                  
                  <video src={require('../../video/homepagw.mov') } 
                   className="video-element"
                  autoplay="true" muted  loop/>
           
         </div>
         
       
            <InfoSec lightBg={lightBg}>
              
               
               
	   
            <Container>
                      <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={3000}>
                            <div>
                                
                            <InfoRow imgStart={imgStart}>
                                                        <InfoColumn>
                                                            <TextWrapper>
                                                            <TopLine lightTopLine={lightTopLine}>{homeObjOne.topLine}</TopLine>
                                                            <Heading lightText={lightText}>{homeObjOne.headline}</Heading>
                                                            <Subtitle lightTextDesc={lightTextDesc}>{homeObjOne.description}</Subtitle>
                                                            </TextWrapper>
                                                        </InfoColumn>
                                                        <InfoColumn>
                                                        
                                                        </InfoColumn>
                                </InfoRow>
                            </div>
                            <div>
                           <InfoRow imgStart={imgStart}>
                                                        <InfoColumn>
                                                            <TextWrapper>
                                                            <TopLine lightTopLine={lightTopLine}>{homeObjTwo.topLine}</TopLine>
                                                            <Heading lightText={lightText}>{homeObjTwo.headline}</Heading>
                                                            <Subtitle lightTextDesc={lightTextDesc}>{homeObjTwo.description}</Subtitle>
                                                            </TextWrapper>
                                                        </InfoColumn>
                                                        <InfoColumn>
                                                        
                                                        </InfoColumn>
                                </InfoRow>
                            </div>
                            <div>
                            <InfoRow imgStart={imgStart}>
                                                        <InfoColumn>
                                                            <TextWrapper>
                                                            <TopLine lightTopLine={lightTopLine}>{homeObjThree.topLine}</TopLine>
                                                            <Heading lightText={lightText}>{homeObjThree.headline}</Heading>
                                                            <Subtitle lightTextDesc={lightTextDesc}>{homeObjThree.description}</Subtitle>
                                                            </TextWrapper>
                                                        </InfoColumn>
                                                        <InfoColumn>
                                                        
                                                        </InfoColumn>
                                </InfoRow>
                            </div>
                           
                        </Carousel>
                </Container>
            </InfoSec>
        </>
    )
}

export default InfoSection;